var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.6233 5C10.8257 4.54416 11.0212 4.1453 11.2101 3.80342C11.4124 3.46154 11.6079 3.17664 11.7968 2.94872H0.00195312V2.05128H11.7968C11.6079 1.80912 11.4124 1.51709 11.2101 1.17521C11.0212 0.833333 10.8257 0.441595 10.6233 0H11.3314C12.1811 1.03989 13.0713 1.80912 14.002 2.30769V2.69231C13.0713 3.17664 12.1811 3.94587 11.3314 5H10.6233Z","fill":"white"}));
}

Arrow.defaultProps = {"width":"15","height":"5","viewBox":"0 0 15 5","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
